import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Lock, Music2, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useMusic } from "@/lib/music/MusicProvider";
import { Connect, isPaid } from "@/components/music/MusicWidget";
import { MusicStudio } from "@/components/inspiration/MusicStudio";

const Soon = () => (
  <div className="grid flex-1 place-items-center p-10" data-testid="insp-coming-soon">
    <div className="max-w-md text-center">
      <Sparkles className="mx-auto h-8 w-8 text-[#F59E0B]" />
      <h2 className="mt-4 font-display text-3xl text-[#F3EBDD]">More coming soon</h2>
      <p className="mt-3 text-sm leading-relaxed text-[#A8A090]">We're building more ways to spark ideas here. Got a wish? Tell us on the <Link to="/updates" className="text-[#F59E0B] hover:underline">Updates &amp; Roadmap</Link> page.</p>
    </div>
  </div>
);

const Gate = ({ m, user }) => {
  if (!isPaid(user)) return (
    <div className="grid flex-1 place-items-center p-10 text-center" data-testid="insp-locked">
      <div><Lock className="mx-auto h-7 w-7 text-[#F59E0B]" /><p className="mt-3 text-sm text-[#A8A090]">The Music Player is free with any paid plan.</p>
        <Link to="/pricing" className="mt-2 inline-block text-sm text-[#F59E0B] hover:underline" data-testid="insp-upgrade-link">See plans</Link></div>
    </div>
  );
  if (!["ready", "session"].includes(m.status)) return <div className="grid flex-1 place-items-center p-10"><div className="w-full max-w-sm rounded-lg border border-[#2D3442] bg-[#0F131A] p-6"><Connect m={m} /></div></div>;
  return <MusicStudio m={m} />;
};

export default function InspirationPage() {
  const { user } = useAuth();
  const m = useMusic();
  const [tab, setTab] = useState("music");
  const T = ({ k, icon: Icon, children }) => (
    <button onClick={() => setTab(k)} className={`inline-flex items-center gap-1.5 border-b-2 px-1 pb-3 text-sm transition-colors ${tab === k ? "border-[#F59E0B] text-[#F3EBDD]" : "border-transparent text-[#A8A090] hover:text-[#F3EBDD]"}`} data-testid={`insp-tab-${k}`}><Icon className="h-4 w-4" />{children}</button>
  );
  return (
    <div className="flex h-[100dvh] flex-col bg-[#0B0D10]" data-testid="inspiration-page">
      <header className="border-b border-[#2D3442] px-8 pt-6">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-[#A8A090] hover:text-[#F3EBDD]" data-testid="insp-back-link"><ChevronLeft className="h-3.5 w-3.5" />Your universes</Link>
        <h1 className="mt-3 font-display text-4xl text-[#F3EBDD] sm:text-5xl">Inspiration</h1>
        <div className="mt-5 flex gap-6"><T k="music" icon={Music2}>Music Player</T><T k="soon" icon={Sparkles}>More coming soon</T></div>
      </header>
      {tab === "music" ? <Gate m={m} user={user} /> : <Soon />}
    </div>
  );
}
